// @flow

import React from 'react';
import ToggleItem from './toggleItem';

const Notifications =
  ({ translate, sms_notification, mail_notification, primary_phone, subscribedToNewsletter, email, changeToggle, application }:
    { translate: any, sms_notification: boolean, mail_notification: boolean, primary_phone: String, subscribedToNewsletter: boolean, email: String, changeToggle: Function, application: Object }) => {

    return (
      <div>
        <div className="u-m-b-40">
          <h3 className="text-center text-green">Indstillinger omkring din forespørgsel</h3>
          <h4 className="text-center">{`(Bestillings ID ${application.order_id})`}</h4>
        </div>
        <div className="settings-area">
          <div className="notify-settings">
            <h2>{translate('settings.get_note')}</h2>
            <div className="row">
              <ToggleItem
                mainParam={sms_notification}
                labelMain='sms_notification'
                icon="phone"
                id={1}
                contact={primary_phone}
                changeToggle={changeToggle}
                translate={translate}
              />
              <ToggleItem
                mainParam={mail_notification}
                labelMain='mail_notification'
                icon="mail"
                id={2}
                contact={email}
                changeToggle={changeToggle}
                translate={translate}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/main/settings/notifications.js